export default {
  namespaced: true,
  hanwha_alarm_profile: {
    title: 'Hanwha alarm profile | Hanwha alarm profiles',
    name: 'Name', description: 'Description', enabled: 'Enabled', rules: 'Rules', dvrs: 'Assigned DVRs',
  },
  hanwha_alarm_rule: {
    title: 'Hanwha alarm rule | Hanwha alarm rules',
    type_log: 'Log type', event_type: 'Alarm event', recovery_event_type: 'Recovery event', channel: 'Channel',
    alarm_type: 'Alarm type', target: 'Target', alarm_message: 'Alarm message', recovery_message: 'Recovery message',
    delay_seconds: 'Delay (seconds)', priority: 'Priority', any_channel: 'Any channel', dvr: 'DVR', camera: 'Camera', enabled: 'Enabled',
  },
}
